import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resetta la posizione di scroll ad ogni navigazione interna.
 * Nota: implementazione volutamente "sempre in alto" (nessun ripristino su back/forward).
 */
export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search]);

  return null;
}
